export const getSearchString = (): string => {
  return window.location.search
}

export const findInURL = (key: string): string | null => {
  const locationSearch = getSearchString()
  const params = new URLSearchParams(locationSearch)
  return params.get(key)
}

const fallbackLocale = "en-GB"

export const getLocale = (): string => {
  const locale = findInURL("locale") || getLocaleFromPath()
  if (locale) {
    return locale
  }
  return fallbackLocale
}

const getLocaleFromPath = (): string | null => {
  const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})\//)
  return match ? match[2] + "-" + match[1].toUpperCase() : null
}

export const getLocalizationEndpoints = () => {
  const locale = getLocale()
  // Utilize hostname to avoid CORS issues in different environments and markets
  const hostname = window.location.hostname;
  if (locale === "") {
    return ["https:/"+ hostname +"/addon-app/translations/kompis/en-GB.json"]
  } else {
    let locales = locale.split("-")
    const countryCode = locales[1].toUpperCase()
    const languageCode = locales[0].toLowerCase()
    return [
      "https://"+ hostname +"/addon-app/translations/kompis/en-GB.json",
      "https://"+ hostname +"/addon-app/translations/kompis/" +
        languageCode +
        "-" +
        countryCode +
        ".json",
    ]
  }
}
